import { defineMessage } from 'react-intl'

import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

export const bringjoy: GetCustomerCopyFunc = () => {
  return {
    generateEligibilityQuestionTitle: () =>
      defineMessage({
        defaultMessage: 'Are you an employee of TikTok/ByteDance?',
        description: 'Asking if the user is an employee of TikTok or ByteDance',
      }),
  }
}
